import { render, staticRenderFns } from "./Regras.vue?vue&type=template&id=03043d29&scoped=true"
import script from "./Regras.vue?vue&type=script&lang=js"
export * from "./Regras.vue?vue&type=script&lang=js"
import style0 from "./Regras.vue?vue&type=style&index=0&id=03043d29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03043d29",
  null
  
)

export default component.exports